var timestamp = new Date().getTime()
module.exports = {
  title: '立项查询宝',
  baseUrl: 'https://test.xxx.com', // 测试项目地址
  baseApi: 'https://test.xxx.com/api', // 测试api请求地址
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: '',
  ZqcUrl: `/zqclj/index.html?time=${timestamp}#/home`,
  ZqcUrlMatterCon: `/zqclj/index.html?time=${timestamp}#/matterCon`,
  ZqcUrlCompanyone: `/zqclj/index.html?time=${timestamp}#/companytwo`,
}
